// ============================================
// Gemini LLM Adapter — NRS.03 LLMProvider (Proxy version)
//
// Redirects all nurse chat traffic through the
// platinumNurseChat Cloud Function for security.
//
// This ensures API keys are never exposed to the client
// and clinical data retrieval happens server-side.
// ============================================

import { API_ENDPOINTS, API_HEADERS } from '../../config/api';

// The interface NRS.03 expects
export interface LLMProvider {
  chat(
    systemPrompt: string,
    history: Array<{ role: 'user' | 'assistant'; content: string }>,
    userMessage: string,
  ): Promise<{ text: string; tokenCount: number }>;
}

/**
 * Create an LLMProvider that proxies through Cloud Functions.
 *
 * @param sessionId — for metadata tracking
 * @param patientId — for server-side lab retrieval
 */
export function createGeminiLLMAdapter(sessionId: string, patientId: string): LLMProvider {
  return {
    async chat(
      _systemPrompt: string, // Ignored: server-side syncClinicalContext handles this
      history: Array<{ role: 'user' | 'assistant'; content: string }>,
      userMessage: string,
    ): Promise<{ text: string; tokenCount: number }> {
      
      const response = await fetch(API_ENDPOINTS.nurseChat, {
        method: 'POST',
        headers: API_HEADERS,
        body: JSON.stringify({
          sessionId,
          patientId,
          userMessage,
          history,
        }),
      });

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(`[NurseProxy] Request failed (${response.status}): ${errText}`);
      }

      const data = await response.json();

      return {
        text: data.text,
        tokenCount: data.tokenCount || 0,
      };
    },
  };
}
